import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Slider from '@mui/material/Slider';
import styled from 'styled-components';


import Title from '../Components/Title'

import { 
    WhiteSpace,
    TextL,
    Button,
    TextLinear,
    TextXL,
    TextMax,
    TextM,
    TextS,
    Hr,
    Input,
    BorderLinearProgress
} from '../../components';

import {
    Card
} from '../../components'

import {
    EtherToInt
} from '../../ethers/e'

import { useTranslation } from 'react-i18next';


function PurchaseFiled({
    slider = false,
    input = {
        value: '',
        onChange: () => {}
    },
    balance = {
        token: 'USDT',
        amount: 0,
        max: null
    }
}) {
    const maxInput = (balance.max && balance.max !== 0) ? Math.min(balance.max, balance.amount) : balance.amount
    const {t} = useTranslation()
    return (
        <Stack>
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems='center'
                sx={{
                    marginBottom: '2px'
                }}
            >
                <TextM color='1'>{t('Balance')}</TextM>
                <TextM color='1'> <TextLinear>{EtherToInt(balance.amount)}</TextLinear> {balance.token}</TextM>
            </Stack>
            <Input input={input}/>
            {
               input.value*1 > maxInput && <TextS color='5'>{t('Maximum Input')} {maxInput}</TextS>
            }
            {
                slider && 
                <Slider
                    size="small"
                    sx={{
                        color:"#f8d83a",
                        width:'96%',
                        margin:'auto'
                    }}
                    defaultValue={(input.value / balance.amount)||0}
                    aria-label="Disabled slider"
                    onChange={v => {
                        input.onChange(Math.floor(maxInput * v.target.value) / 100)
                    }}
                />
            }
        </Stack>
    )
}

export default PurchaseFiled


export function InvitInput({input}) {
    const {t} = useTranslation()
    return (
        <div>
            <TextM
                style={{
                    marginBottom: '4px',
                    display: 'block'
                }}
            >{t('Inviter Address')}</TextM>
            <Input input={input}/>
        </div>
    )
}

// export function 